import { jsx as _jsx } from "react/jsx-runtime";
import '@styles/webdesktop/stylesheets/customizeAirDatePicker.scss';
import 'air-datepicker/air-datepicker.css';
import { useEffect, useRef } from 'react';
import { generateDateTimePickerLocalization } from '@front/controls/elements/DateTimePicker/DateTimePickerLocalization';
import AirDatepicker from 'air-datepicker';
export const AirDatepickerReact = (props) => {
    const containerRef = useRef(null);
    const datePicker = useRef(null);
    useEffect(() => {
        datePicker.current = new AirDatepicker(containerRef.current, Object.assign({ autoClose: false, prevHtml: '<svg viewBox="0 0 16 16" fill="none"><path d="M6.53609 7.55427L10.999 11.5601L11 13.0001L4.99996 7.56355L10.999 2.00007L10.998 3.44001L6.53609 7.55427Z" fill="currentColor"/></svg>', nextHtml: '<svg viewBox="0 0 16 16" fill="none"><path d="M9.46391 7.55414L5.00102 11.56L5.00005 12.9999L11 7.56342L5.00102 1.99994L5.002 3.43988L9.46391 7.55414Z" fill="currentColor"/></svg>', inline: true, locale: generateDateTimePickerLocalization(), toggleSelected: false, fixedHeight: true }, props));
    }, []);
    useEffect(() => {
        datePicker.current.update(Object.assign({}, props));
    }, [props]);
    return _jsx("div", { className: "inline-air-datepicker", ref: containerRef });
};
